import { Component, OnInit } from '@angular/core';
import { ConfiguracaoImpressao, ImpressaoService } from '../services/impressao.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SnackbarService } from '../services/snackbar.service';
import { ApiService } from '../services/api.service';
import { NotificacaoService } from '../services/notificacao.service';
import { AppService } from '../services/app.service';
import { KanbanService } from '../services/kanban.service';

@Component({
  selector: 'app-impressao',
  templateUrl: './impressao.component.html',
  styleUrls: ['./impressao.component.scss']
})
export class ImpressaoComponent implements OnInit {

  fileContent: any;

  constructor(
    public impressaoService: ImpressaoService,
    private formBuilder: FormBuilder,
    private snackbarService: SnackbarService,
    private apiService: ApiService,
    private notificacaoService: NotificacaoService,
    public kanbanService: KanbanService
  ) { }

  configuracao: ConfiguracaoImpressao;
  form: FormGroup;
  formNotificacao: FormGroup;

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      impressora: [""],
      numeroCopias: ["1",],
      disparoImpressao: ["MANUAL"],
      numeroColunas: ["40"],
      avancoPapelFinal: ["2"]
    });


    this.formNotificacao = this.formBuilder.group({
      repetirSomPedidoPendente: ["LIGADO"],
      volume: [100],
      notificacao: ["default"],
      numeroRepeticoes: ["1"],
      repetirSomPedidoPendentePeriodo: [300],
      tempoPermanenciaNoMonitor: ["24"]
    });

    if (!!this.impressaoService.configuracao) {
      this.form.patchValue({ ...this.impressaoService.configuracao })
    }

    if (!!this.notificacaoService.configuracao) {
      console.log(this.notificacaoService.configuracao);
      this.formNotificacao.patchValue({ ...this.notificacaoService.configuracao })
    }

    this.formNotificacao.valueChanges.subscribe((value) => {
      this.notificacaoService.salvarConfiguracao(value);
    });

    if (!this.impressaoService.driverEstaAtivo)
      this.impressaoService.start();
  }


  salvarConfiguracao() {
    this.impressaoService.salvarConfiguracao(this.form.value);
    this.notificacaoService.salvarConfiguracao(this.formNotificacao.value);
    this.snackbarService.Success("Dados salvos com sucesso!");

    setTimeout(() => {
      location.reload();
    }, 1000);
  }

  testar() {
    this.apiService.getImpressaoTesteEscPos(this.impressaoService.numeroColunas).subscribe((retorno) => {
      if (retorno.status === "success") {
        const buffer = this.impressaoService.imprimirEscPos(retorno.data);
      }
    })
  }

  testarSom() {
    this.notificacaoService.tocarSom();
  }

  public onLoadCertificados(fileList: FileList): void {
    const self = this;

    for (let i = 0; i < fileList.length; i++) {

      const name = fileList.item(i).name;

      const validFiles = ['private-key.pem', 'digital-certificate.txt'];

      if (!validFiles.includes(name)) {
        continue;
      }


      if (name === 'private-key.pem') {
        const filePrivateKey = new FileReader();
        filePrivateKey.onloadend = (x) => {
          self.impressaoService.setChaveCertificado(String(filePrivateKey.result));
        }
        filePrivateKey.readAsText(fileList.item(i));
      }

      if (name === 'digital-certificate.txt') {
        const fileCertificate = new FileReader();
        fileCertificate.onloadend = (x) => {
          self.impressaoService.setCertificado(String(fileCertificate.result));
        }
        fileCertificate.readAsText(fileList.item(i));
      }

    }

  }
}